<script lang="ts">
	interface Props {
		className?: string;
		strokeWidth?: number;
	}

	let { className = '', strokeWidth = 2 }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			id="Vector"
			d="M4 18H14M4 14H20M4 10H14M4 6H20"
			stroke="currentColor"
			stroke-width={strokeWidth}
			stroke-linecap="round"
			stroke-linejoin="round"
		></path>
	</svg>
</div>
